module.exports = __webpack_public_path__ + "img/monitor_78.0a6cea26.jpg";